import palette from '../palette';
import shadows from '../shadows';

const MuiToolbar = {
  variants: [
    {
      props: { variant: 'toolbar-button-menu' },
      style: {
        backgroundColor: palette.surface.white,
        boxShadow: shadows[1],
        display: 'flex',
        height: 48,
        minHeight: { xs: 48 },
        padding: 0,
        position: 'fixed',
        top: 64,
        width: '100%',
        zIndex: 10,
      },
    },
  ],
};

export default MuiToolbar;
